export function cleanMetaString(s) {
  if (!s)
    return s
  return s.replaceAll('"', '\'')
}
